<template>
  <div class="buylist-cell">
    <div class="timestr">{{byear}}</div>
    <div class="linetop"></div>
    <div class="pic">
      <img :src="iconUrl" width="100%" height="100%" />
    </div>
    <div class="text">
      <p class="top">{{name}}</p>
      <p class="bottom">{{year}}年日历</p>
      <p class="bottomprice">¥ {{buyprice}}</p>
      <div class="linebottom"></div>
      <button class="btn" @click="preview()">查看详情</button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'BuyListCell',
  props: {
    name: String,
    iconUrl: String,
    year: Number,
    byear: String,
    buyprice: Number
  },
  methods: {
    preview () {
      this.$emit('preview')
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/mixins.styl'

.buylist-cell {
  width: 343px;
  height: 192px;
  background: #ffffff;
  border-radius: 6px;
  padding: 15px;
  box-sizing: border-box;
  margin-bottom: 20px;
  position: relative;
  rowCenter();

  .timestr {
    font-size: 12px;
    position: absolute;
    left: 18px;
    top: 16px;
    color: #444444;
  }

  .linetop {
    position: absolute;
    top: 40px;
    left: 18px;
    right: 18px;
    height: 1px;
    background-color: #D8D8D8;
  }

  .pic {
    margin-top: -10px;
    width: 70px;
    height: 70px;
    border-radius: 5px;
    overflow: hidden;
  }

  .text {
    padding-left: 15px;

    p {
      line-height: 15px;
      height: 24px;
      color: #333333;
    }

    .top {
      font-size: 14px;
      color: #444444;
    }

    .bottom {
      font-size: 12px;
      color: #666666;
    }

    .bottomprice {
      font-size: 16px;
      color: #FF0000;
    }

    .linebottom {
      position: absolute;
      bottom: 50px;
      left: 18px;
      right: 18px;
      height: 1px;
      background-color: #D8D8D8;
    }

    .btn {
      width: 72px;
      height: 30px;
      background: transparent;
      color: #333333;
      border: 1px solid #000000;
      font-size: 12px;
      line-height: 25px;
      border-radius: 3px;
      position: absolute;
      right: 18px;
      bottom: 10px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/BuyList/components/BuyListCell.vue